import JalaliMoment from "jalali-moment";

export const formatTimestamp = (timestamp: number): string => {
	const date = new Date(timestamp);
	const now = new Date();

	const timeDiff = now.getTime() - date.getTime();
	const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

	if (daysDiff === 0) return "امروز";
	if (daysDiff === 1) return "دیروز";
	if (daysDiff < 30) return `${daysDiff} روز پیش`;

	const monthsDiff =
		now.getMonth() -
		date.getMonth() +
		12 * (now.getFullYear() - date.getFullYear());

	if (monthsDiff < 12) return `${monthsDiff} ماه پیش`;

	const yearsDiff = now.getFullYear() - date.getFullYear();
	if (yearsDiff === 1) return `${yearsDiff} سال پیش`;

	return date.toLocaleDateString("fa-IR");
};

export interface TimeAgoResult {
	value: string;
	unit: string;
	color: string;
	fullDate: string;
}

export const getTimeAgo = (dateString: string): TimeAgoResult => {
	const now = JalaliMoment();
	const targetDate = JalaliMoment(dateString);
	const diffInSeconds = now.diff(targetDate, "seconds");
	const diffInMinutes = now.diff(targetDate, "minutes");
	const diffInHours = now.diff(targetDate, "hours");
	const diffInDays = now.diff(targetDate, "days");
	const diffInMonths = now.diff(targetDate, "months");
	const diffInYears = now.diff(targetDate, "years");

	let value = 0;
	let unit = "";
	let color = "text-light-lime";

	if (diffInYears > 0) {
		value = diffInYears;
		unit = "سال قبل";
		color = "text-gray-400";
	} else if (diffInMonths > 0) {
		value = diffInMonths;
		unit = "ماه قبل";
		color = "text-light-blue";
	} else if (diffInDays > 0) {
		value = diffInDays;
		unit = "روز قبل";
		color = "text-light-blue";
	} else if (diffInHours > 0) {
		value = diffInHours;
		unit = "ساعت قبل";
		color = "text-light-lime";
	} else if (diffInMinutes > 0) {
		value = diffInMinutes;
		unit = "دقیقه قبل";
		color = "text-light-lime";
	} else {
		value = diffInSeconds;
		unit = "ثانیه قبل";
		color = "text-light-lime";
	}

	const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
	const persianValue = value
		.toString()
		.replace(/\d/g, (digit) => persianNumbers[parseInt(digit)]);

	return {
		value: persianValue,
		unit,
		color,
		fullDate: targetDate.locale("fa").format("YYYY/MM/DD"),
	};
};
